import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { GrupoServicioSolicitadoDTO } from "app/main/apps/shared/interfaces/grupo-servicio-solicitado.interface";
import { CodigoServicioDTO } from "app/main/apps/shared/interfaces/grupo-servicio.interface";
import { ContratistaService } from "app/main/apps/shared/services/rest/contratista.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

@Component({
    selector: "app-especialidades",
    templateUrl: "./especialidades.component.html",
    styleUrls: ["./especialidades.component.scss"],
})
export class EspecialidadesComponent implements OnInit {
    @Input() especialidades: CodigoServicioDTO[];
    @Input() eliminado: boolean;
    @Output() eliminarEspecialidad: EventEmitter<{
        especialidad: CodigoServicioDTO;
        nuevasEspecialidades: number[];
    }> = new EventEmitter();
    @Output() agregarEspecialidades: EventEmitter<void> = new EventEmitter();

    constructor(
        public _menuUsuarioSrvc: MenuUsuarioService,
        private _contratistaSrvc: ContratistaService
    ) {}

    ngOnInit(): void {
        this._contratistaSrvc.especialidadesChanged$.subscribe((resp) => {
            //console.log('cambio');
            //console.log(this.especialidades);
        });
    }

    eliminar(especialidad: CodigoServicioDTO) {
        //console.log("llego");

        const nuevasEspecialidades = this.especialidades
            .filter((espec) => espec.id !== especialidad.id)
            .map((espec) => espec.id);

        const data = {
            especialidad,
            nuevasEspecialidades,
        };
        this.eliminarEspecialidad.emit(data);
    }

    agregarEspecialidad() {
        this.agregarEspecialidades.emit();
    }
}
